<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DqgWEE/tc-custom/9781466867376.jpg?1737196543377" alt="This image is the cover for the book Nostradamus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nostradamus
      </h1>
      <p class="bookDescription body article font2">
        <p>For the last 500 years the predictions of sixteenth-century physician and prophet Michel de Nostredame, better known as Nostradamus, have been endlessly interpreted. Scholars and skeptics have hotly debated whether the 946 "quatrains" he wrote foretold everything from the discovery of electricity to the birth of Adolph Hitler, the death of Princess Diana and the attack on the World Trade Center.<br/><br/>But while much has been written about Nostradamus's predictions and their validity, little is known of the man.  This definitive biography by bestselling historian Ian Wilson reveals the man behind the legend for the first time. Tracing Nostradamus's life from his early years to his skillful treatment of Black Plague sufferers, his flight from agents of the Spanish Inquisition, and his career as an advisor to the king of France, Nostradamus separates fact from fiction and reveals a complex figure who, whether or not he could see future events, was indelibly marked by those of his own time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Wilson
      </h2>
      
      <p class="authorDescription body article"><P><B>Ian Wilson</B> is the author of the highly acclaimed bestsellers <I>The Turin Shroud</I>, <I>The Blood and the Shroud</I>, <I>Jesus: The Evidence</I> and <I>Before the Flood</I>. Wilson lives in Queensland, Australia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Griffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d9822c7